export  const  noDataText="Немає даних";
export  const previousText='Попередня сторінка';
export  const nextText='Наступна сторінка';
export  const loadingText='Завантаження...';
export  const pageText='Сторінка';
export  const ofText='з';
export  const rowsText='рядків';